<template>
  <v-tooltip opacity="1" :location="direction" :disabled="disabled" :max-width="maxWidth">
    <template #activator="{ props }">
      <span :class="activatorClass" v-bind="props">
        <slot />
      </span>
    </template>

    <span v-if="!largeTooltip" class="icon-tooltip-container tooltip-multiline" v-html="tooltipText" />

    <div v-else class="large-tooltip-container">
      <div class="large-tooltip-title">
        <v-icon color="#ffffff" :class="largeTooltipIconClass">{{ largeTooltipIcon }}</v-icon>
        {{ largeTooltipTitle }}
      </div>

      <div class="large-tooltip-content">
        <slot name="largeTooltipContent" />
      </div>
    </div>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    activatorClass: {
      type: String,
    },

    tooltipText: {
      type: [String, Number],
      required: false,
    },

    largeTooltip: {
      type: Boolean,
      default: false,
    },

    largeTooltipTitle: {
      type: String,
      required: false,
    },

    largeTooltipIcon: {
      type: String,
      required: false,
    },

    largeTooltipIconClass: {
      type: String,
      required: false,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    top: {
      type: Boolean,
      default: true,
    },

    bottom: {
      type: Boolean,
      default: false,
    },

    left: {
      type: Boolean,
      default: false,
    },

    right: {
      type: Boolean,
      default: false,
    },

    direction: {
      type: String,
      default: 'top',
      validator: (val) => ['top', 'bottom', 'left', 'right', 'start', 'end', 'top start'].includes(val),
    },

    maxWidth: {
      type: Number,
      default: undefined,
    },
  },
};
</script>

<style scoped lang="scss"></style>
